import {useParams} from 'react-router-dom';
import {usePreviewProject} from 'api/generated';
import {NoCodeRenderer} from 'components/no-code';
import {useTitle} from 'hooks';

interface IPageARPreviewProps {}

const PageARPreview = ({}: IPageARPreviewProps) => {
  useTitle('AR Preview');

  const params = useParams();
  const handle = params.handle ?? '';
  const token = params.project ?? '';

  const {data: projectData, isPending} = usePreviewProject(token, {handle}, {query: {enabled: !!handle && !!token}});
  const project = projectData?.data?.data;

  return <NoCodeRenderer projectState="preview" project={project} isPending={isPending} />;
};

export default PageARPreview;
